import React from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';
import { factorDataDisplayContext, factorDataUpdateExplanation } from '../../../context/factorDataSyncPolicy';
import { formatUserFactorModel } from '../../../utils/factorDataOptions';

export default function FactorDataUpdateDialog({ sync, suppressed = false }) {
    const current = factorDataDisplayContext(sync.status?.saved);
    const available = factorDataDisplayContext(sync.status?.available);
    const describe = (context) => context
        ? [formatUserFactorModel(context.factorModel), context.factorDataModel, context.factorSnapshotDate].filter(Boolean).join(' · ')
        : 'Unavailable';
    return (
        <>
            <Dialog open={Boolean(sync.promptOpen) && !suppressed} onClose={sync.busy ? undefined : sync.dismissPrompt} maxWidth="sm" fullWidth>
                <DialogTitle>New factor data available</DialogTitle>
                <DialogContent dividers>
                    <Typography paragraph>{factorDataUpdateExplanation(sync.status)}</Typography>
                    <Typography variant="body2">Using now: {describe(current)}</Typography>
                    <Typography variant="body2">Available: {describe(available)}</Typography>
                </DialogContent>
                <DialogActions>
                    <Button onClick={sync.dismissPrompt} disabled={sync.busy}>Later</Button>
                    <Button variant="contained" onClick={sync.applyUpdate} disabled={sync.busy}>{sync.busy ? 'Checking your Watchlist…' : 'Use new factor data'}</Button>
                </DialogActions>
            </Dialog>
        </>
    );
}
